import { useState } from "react";
import { BarChart3, BookOpen, FileUp, LogOut, Menu, MessageSquareText, Settings, Users, X } from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";
import { PandaAssistantIcon } from "./PandaAssistantIcon";

const nav = [
  { to: "/", label: "数据总览", icon: BarChart3, end: true },
  { to: "/upload", label: "资料分析", icon: FileUp },
  { to: "/cases", label: "处理记录", icon: MessageSquareText },
  { to: "/knowledge", label: "知识库", icon: BookOpen },
  { to: "/team", label: "团队表现", icon: Users },
  { to: "/settings", label: "业务设置", icon: Settings }
];

export function AppLayout({ onLogout }: { onLogout: () => void }) {
  const [menu, setMenu] = useState(false);
  return <div className="app-shell">
    <aside className={`sidebar ${menu ? "open" : ""}`}>
      <div className="brand"><span className="brand-mark"><img src="/yida-logo.png" alt="亿大口腔" /></span><span><strong>亿大口腔智能体</strong><small>YIDA DENTAL AI</small></span><button className="icon-button sidebar-close" onClick={() => setMenu(false)} title="关闭菜单"><X size={19} /></button></div>
      <NavLink to="/knowledge-ask" onClick={() => setMenu(false)} className={({ isActive }) => `sidebar-agent-card${isActive ? " active" : ""}`}><span className="sidebar-agent-surface"><PandaAssistantIcon className="sidebar-agent-icon" /><strong>亿大口腔 AGENT</strong></span></NavLink>
      <div className="nav-label">工作台</div>
      <nav>{nav.map(({ to, label, icon: Icon, end }) => <NavLink key={to} to={to} end={end} onClick={() => setMenu(false)} className={({ isActive }) => isActive ? "active" : ""}><Icon size={18} strokeWidth={1.8} /><span>{label}</span></NavLink>)}</nav>
      <button className="user-panel" onClick={onLogout} title="退出登录"><span className="avatar">管</span><span><strong>系统管理员</strong><small>Administrator</small></span><LogOut size={16} /></button>
    </aside>
    {menu && <button className="sidebar-overlay" aria-label="关闭菜单" onClick={() => setMenu(false)} />}
    <main className="main-area">
      <header className="app-topbar">
        <button className="mobile-menu icon-button" onClick={() => setMenu(true)} title="打开菜单"><Menu size={21} /></button>
        <div className="topbar-context"><span>亿大口腔运营中心</span><small>智能对话质量管理</small></div>
      </header>
      <Outlet />
    </main>
  </div>;
}
